import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createCalificacionesProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider[] => {
    const calificacionesCatalogoMateriasProvider: ISearchProvider = {
        key: "calificaciones-catalogo-materias",
        label: "Calificaciones: Catálogo de materias",
        subLabel: "Gestión de materias para calificaciones",
        action: ctx.navigateModule("calificaciones/materias"),
        search: (): ISearchResult[] => ([]),
    };

    const calificacionesBoletasGeneradasProvider: ISearchProvider = {
        key: "calificaciones-boletas-generadas",
        label: "Calificaciones: Boletas generadas",
        subLabel: "Visualización de boletas de calificaciones generadas",
        action: ctx.navigateModule("calificaciones/boletasgeneradas"),
        search: (): ISearchResult[] => ([]),
    };

    const calificacionesMateriasCalificadasPorAlumnoProvider: ISearchProvider = {
        key: "calificaciones-materias-calificadas-por-alumno",
        label: "Calificaciones: Materias calificadas por alumno",
        subLabel: "Visualización de materias calificadas por alumno",
        action: ctx.navigateModule("calificaciones/materiascalificadas"),
        search: (): ISearchResult[] => ([]),
    };

    return [
        calificacionesCatalogoMateriasProvider,
        calificacionesBoletasGeneradasProvider,
        calificacionesMateriasCalificadasPorAlumnoProvider,
    ];
};